// Section base path → its task-detail route literal. Keys are matched against
// the FIRST path segment of the current location so nested paths (e.g.
// `/controls/SOC2`) still resolve to the section route.
export const sectionTaskDetailRoutes = {
  '/risks': '/risks/tasks/$taskId',
  '/documents': '/documents/tasks/$taskId',
  '/trust': '/trust/tasks/$taskId',
  '/people': '/people/tasks/$taskId',
  '/vendors': '/vendors/tasks/$taskId',
  '/assets': '/assets/tasks/$taskId',
  '/integrations': '/integrations/tasks/$taskId',
  '/meetings': '/meetings/tasks/$taskId',
  '/controls': '/controls/tasks/$taskId',
} as const;

export type TaskSectionBasePath = keyof typeof sectionTaskDetailRoutes;

export type TaskDetailRoute =
  | (typeof sectionTaskDetailRoutes)[TaskSectionBasePath]
  | '/tasks/$taskId';

// Returns the task-detail route for the section the pathname belongs to,
// defaulting to the neutral '/tasks/$taskId' (home / unknown sections).
export function getTaskDetailRoute(pathname: string): TaskDetailRoute {
  const firstSegment = `/${pathname.split('/')[1] ?? ''}`;
  const sectionRoute =
    sectionTaskDetailRoutes[firstSegment as TaskSectionBasePath];
  return sectionRoute ?? '/tasks/$taskId';
}
